import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import {
  selectors as configSelectors,
  redirectToSignificantPeoplePage
} from '../../infrastructure/config';
import PrimaryApplicantWaitingPage from './primaryApplicantWaitingPage';

const PRIMARY_APPLICANT_FLOW = 'primary_applicant';
class primaryApplicantWaiting extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.history.push('/');
  }

  render() {
    const { bankId, redirectToSignificantPeoplePage } = this.props;
    return (
      <PrimaryApplicantWaitingPage
        bankId={bankId}
        onEditButtonClick={() => {
          redirectToSignificantPeoplePage(PRIMARY_APPLICANT_FLOW);
        }}
      />
    );
  }
}

primaryApplicantWaiting.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: configSelectors.bankId(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      redirectToSignificantPeoplePage
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(primaryApplicantWaiting);
